import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useWeb3 } from './contexts/Web3Context';
import './index.css'; 
import LandingPage from './components/LandingPage';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Verification from './components/Verification';
import VerificationSuccess from './components/VerificationSuccess';
import VerificationError from './components/VerificationError';
import PasslyDocs from './components/Docs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  const { account, isConnected } = useWeb3();
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (isConnected || account === null) {
      setLoading(false);
    }
  }, [account, isConnected]);


  useEffect(() => {

    if (process.env.NODE_ENV === 'production') {
      
      const interval = 5 * 60 * 1000;
      
     
      const sendHeartbeat = async () => {
        try {
     
          const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
          const heartbeatUrl = `${apiUrl.replace(/\/api\/?$/, '')}/heartbeat`;
          
     
          await fetch(heartbeatUrl, {
            method: 'GET',
            cache: 'no-cache',
            headers: {
              'Cache-Control': 'no-cache'
            }
          });
        } catch (error) {
       
        }
      };
      
     
      sendHeartbeat();
      
     
      const heartbeatInterval = setInterval(sendHeartbeat, interval);
      
  
      return () => clearInterval(heartbeatInterval);
    }
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loader"></div>
        <p className="loading-text">Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <Toaster 
        position="bottom-left"
        reverseOrder={true}
        gutter={12}
        containerStyle={{
          bottom: '20px',
          left: '20px',
          zIndex: 9999,
        }}
        containerClassName="toast-container"
        toastOptions={{
          duration: 4000,
          position: 'bottom-left',
          style: {
            borderRadius: '12px',
            maxWidth: '400px',
            minWidth: '300px',
            padding: '16px 20px',
            fontSize: '14px',
            fontWeight: '500',
            color: 'white',
            border: 'none',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
          },
          success: {
            style: {
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.95) 0%, rgba(5, 150, 105, 0.95) 100%)',
              border: '1px solid rgba(16, 185, 129, 0.3)',
            },
          },
          error: {
            style: {
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.95) 0%, rgba(220, 38, 38, 0.95) 100%)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
            },
          },
        }}
      />
      <Routes>
      
        <Route path="/" element={<LandingPage />} />

       
        <Route path="/docs" element={<PasslyDocs />} />
        
      
        <Route path="/app" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              <Dashboard />
            </main>
          </div>
        } />
        
  
        <Route path="/passport" element={<Navigate to="/app" />} />
        
      
        <Route path="/verification/twitter" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              {isConnected ? <Verification platform="twitter" /> : <Navigate to="/app" />}
            </main>
          </div>
        } />

        <Route path="/verification/github" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              {isConnected ? <Verification platform="github" /> : <Navigate to="/app" />}
            </main>
          </div>
        } />

        <Route path="/verification/github/success" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              <VerificationSuccess platform="github" />
            </main>
          </div>
        } />

        <Route path="/verification/github/error" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              <VerificationError platform="github" />
            </main>
          </div>
        } />
        
        <Route path="/verification/twitter/success" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              <VerificationSuccess platform="twitter" />
            </main>
          </div>
        } />
        
        <Route path="/verification/twitter/error" element={
          <div className="app-wrapper">
            <Header />
            <main className="app-main">
              <VerificationError platform="twitter" />
            </main>
          </div>
        } />

        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        
     
        <Route path="*" element={<Navigate to="/app" />} />
      </Routes>
    </Router>
  );
}

export default App;